import * as React from "react";
import { Input, Form, Button, Upload, InputNumber } from "antd";
import { FormInstance } from "antd/lib/form";
import { ICourtCase } from "../../model/CourtCase";
import { UploadOutlined } from "@ant-design/icons";
import { IAttachment } from "../../model/Attachment";
import { DateFormats } from "../../../core/common/Constants";
import DateTimePicker from "../../../core/ui/components/DateTimePicker";
import FormSection from "../../../core/ui/components/FormSection";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import SelectInput from "../../../core/ui/components/SelectInput";
const FormFields = {
  COURT_CASE_NUMBER: "courtCaseNumber",
  CONNECTION_TYPE: "connectionType",
  CASE_DESCRIPTION: "caseDescription",
  ANONYMIZED_CASE_DESCRIPTION: "anonymizedCaseDescription",
  CAS_ID: "casId",
  CPH_ID: "cphId",
  CASE_TYPE: "caseType",
  CASE_PHASE_TYPE: "casePhaseType",
  JUDGE1: "judge1",
  JUDGE2: "judge2",
  JUDGE3: "judge3",
  CLOSED_BY_JUDGE: "closedByJudge",
  CASE_BEGIN_DATE: "caseBeginDate",
  BEGIN_DATE: "beginDate",
  END_DATE: "endDate",
  CASE_STATUS: "caseStatus",
  CASE_CLOSING_WAY: "caseClosingWay",
  CASE_LAW_DOCUMENT_COURT_CASE_TYPE: "type",
  CASE_DECISION_NAME: "caseDecisionName",
  CASE_DECISION_ATTACHMENT: "caseDecisionAttachment",
  CASE_DECISION_DATE: "decisionDate"
};
export interface State {
  fileUploaded?: boolean;
}
export interface Props {
  translate: any;
  form: FormInstance;
  rowData?: ICourtCase;
  uploadedAttachment?: IAttachment;
  courtCaseTypes: IGenericCodebookItem[];
  setFileValue: (file: any, fileName?: string) => any;
  decisionTypes: IGenericCodebookItem[];
}

export default class CourtCaseCreationForm extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = { fileUploaded: false };
  }
  onChange = (file) => {
    let fileName = this.props.rowData
      ? this.props.rowData.courtCaseNumber + "." + file.name.split(".").pop()
      : file.name;
    this.props.setFileValue(file, fileName);

    this.setState({ fileUploaded: file ? true : false });
    this.props.form.setFieldsValue({
      caseDecisionAttachment: this.props.uploadedAttachment
    });
  };
  render() {
    const {
      translate,
      rowData,
      form,
      uploadedAttachment,
      decisionTypes,
      courtCaseTypes
    } = this.props;

    return (
      <Form layout={"vertical"} form={form}>
        <FormSection
          title={translate("editors.court_cases.court_case")}
          subtitle={translate("editors.court_cases.data")}
        >
          <Form.Item
            initialValue={rowData?.courtCaseNumber}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_documents.required_messages",
                  {
                    field: translate(
                      "editors.case_law_documents.case_law_document_type"
                    )
                  }
                )
              }
            ]}
            label={translate(
              "editors.case_decisions.court_case.court_case_number"
            )}
            name={FormFields.COURT_CASE_NUMBER}
          >
            <Input />
          </Form.Item>

          <Form.Item
            initialValue={rowData?.type}
            label={translate(
              "editors.case_decisions.court_case.court_case_number"
            )}
            style={{ display: "none" }}
            name={FormFields.CASE_LAW_DOCUMENT_COURT_CASE_TYPE}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_documents.required_messages",
                  {
                    field: translate(
                      "editors.case_law_documents.case_law_document_type"
                    )
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.type")}
            name={FormFields.CONNECTION_TYPE}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate(
              "editors.case_decisions.court_case.case_description"
            )}
            name={FormFields.CASE_DESCRIPTION}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate(
              "editors.case_decisions.court_case.anonymized_case_description"
            )}
            name={FormFields.ANONYMIZED_CASE_DESCRIPTION}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.cas_id")}
            name={FormFields.CAS_ID}
            style={{ display: "none" }}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.cph_id")}
            name={FormFields.CPH_ID}
            style={{ display: "none" }}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label={translate("editors.case_decisions.court_case.casePhaseType")}
            name={FormFields.CASE_PHASE_TYPE}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.judge1")}
            name={FormFields.JUDGE1}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.judge2")}
            name={FormFields.JUDGE2}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.judge3")}
            name={FormFields.JUDGE3}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.closedByJudge")}
            name={FormFields.CLOSED_BY_JUDGE}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label={translate("editors.case_decisions.court_case.case_type")}
            name={FormFields.CASE_TYPE}
          >
            <SelectInput
              placeholder={translate(
                "editors.case_decisions.select_organisation"
              )}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"code"}
              selectOptionValue={"value"}
              selectOptions={courtCaseTypes}
            />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.court_case.caseStatus")}
            name={FormFields.CASE_STATUS}
            style={{ display: "none" }}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label={translate(
              "editors.case_decisions.court_case.caseClosingWay"
            )}
            style={{ display: "none" }}
            name={FormFields.CASE_CLOSING_WAY}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
        </FormSection>
        <FormSection
          title={translate("editors.case_decisions.case_decision")}
          subtitle={translate("editors.case_decisions.basic_data")}
        >
          <Form.Item
            label={"Naziv"}
            name={FormFields.CASE_DECISION_NAME}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_documents.required_messages",
                  {
                    field: translate(
                      "editors.case_law_documents.case_law_document_type"
                    )
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={"Datum odluke"}
            name={FormFields.CASE_DECISION_DATE}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_documents.required_messages",
                  {
                    field: translate(
                      "editors.case_law_documents.case_law_document_type"
                    )
                  }
                )
              }
            ]}
          >
            <DateTimePicker
              placeholder={translate("date_picker.placeholder")}
              format={DateFormats.DATE}
              showToday={true}
              className={"input-date-wrapper"}
              translate={translate}
            />
          </Form.Item>
          <Form.Item
            label={translate("editors.case_decisions.decision_type")}
            name={"decisionTypeId"}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_documents.required_messages",
                  {
                    field: translate(
                      "editors.case_law_documents.case_law_document_type"
                    )
                  }
                )
              }
            ]}
          >
            <SelectInput
              placeholder={translate(
                "editors.attachment_types.select_content_type"
              )}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"id"}
              selectOptionValue={"value"}
              selectOptions={decisionTypes}
            />
          </Form.Item>
          <Form.Item>
            <Upload
              maxCount={1}
              onChange={(e) => this.onChange(e.file)}
              beforeUpload={(file, fileList) => {
                return false;
              }}
              onRemove={(file) => {
                this.setState({
                  fileUploaded: false
                });
              }}
              showUploadList={{
                showRemoveIcon: true
              }}
              listType="picture"
            >
              {!uploadedAttachment && (
                <Button type={"default"}>
                  <UploadOutlined />
                  {translate("form_details.select_document")}
                </Button>
              )}
            </Upload>
          </Form.Item>
        </FormSection>
      </Form>
    );
  }
}
